﻿import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconMap2 } from "@tabler/icons-react";
import { ZonasHorariasDef } from "./ZonasHorariasDef";

export const ZonasHorariasIcon = IconMap2;
export const ZonasHorariasHelpText = "* Aqui tendra la lista de las zonas horarias.";

export class ZonasHorarias extends Entity<ZonasHorariasDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new ZonasHorariasDef(), parentKeys);
        super.Form = import('./ZonasHorariasForm').then((module) => module.ZonasHorariasForm);
        this.Title = "Zonas Horarias";
        this.Icon = ZonasHorariasIcon;
        this.HelpText = ZonasHorariasHelpText;
    }
}   